// La barre du navigateur (Safari, signet sur l'écran d'accueil) prend la couleur de la meta theme-color. Le layout la
// pose en blanc : en mode sombre, la barre restait blanche au-dessus d'une page sombre. Elle suit le fond du thème
// porté par le body. Le script en ligne du layout (layouts/_body) la pose avant le premier rendu ; ici, une bascule de
// thème, et une visite Turbo, dont la fusion du <head> remet le blanc du layout.
export function syncThemeColor() {
  const meta = document.querySelector('meta[name="theme-color"]')
  if (!meta || !document.body) return

  const background = getComputedStyle(document.body).getPropertyValue("--bs-body-bg").trim()
  if (background && meta.content !== background) meta.content = background
}

export function startThemeColorSync() {
  document.addEventListener("depozen:theme-changed", syncThemeColor)
  document.addEventListener("turbo:render", syncThemeColor)
  document.addEventListener("turbo:load", syncThemeColor)
  syncThemeColor()
}
